module.exports = __webpack_public_path__ + "img/img-full-copy.1118309c.jpg";